import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StatusCodePipe } from './status-code/status-code.pipe';
import { HealthCodePipe } from './health-code/health-code.pipe';
import { WeatherIconPipe } from './weather-icon/weather-icon.pipe';
import { CapitalizeFirstPipe } from './capitalize-first/capitalize-first.pipe';
import { NoUnderscorePipe } from './no-underscore/no-underscore.pipe';
import { WhitespaceToUnderscorePipe } from './whitespace-to-underscore/whitespace-to-underscore.pipe';
import { ValueToMonthPipe } from './value-to-month/value-to-month.pipe';
import { MonitorAlarmPipe } from './monitor-alarm/monitor-alarm.pipe';
import { ConvertPowerPipe } from './convert-power/convert-power.pipe';
import { FileServerUrlPipe } from './file-server-url/file-server-url.pipe';
import { DurationPipe } from './duration/duration.pipe';
import { SignalPropertiesPipe } from './signals/signals-properties.pipe';
import { LoadPipe } from './load/load.pipe';
import { UserAccessPipe } from './user-access/user-access.pipe';
import { CurrencyUnitsPipe } from './currency-units/currency-units.pipe';
import { DateDifferencePipe } from './date-difference/date-difference.pipe';
import { ColorStatusCodePipe } from './color-status/color-status.pipe';
import { ImageSrcDependsOnThemePipe } from './image-src-depends-on-theme/image-src-depends-on-theme.pipe';
import { ThemeColorPipe } from './theme-color/theme-color.pipe';
import {NegativeToZeroPipe} from './negative-to-zero/negative-to-zero.pipe';
import { PlaningEventCategoryColorPipe } from './planing-event-category-color/planing-event-category-color.pipe';
import { CustomTranslatePipe } from './translate/custom-translate.pipe';
import {GetKpiForTablePipe} from './kpi-for-table/get-kpi-fot-table.pipe';
import {TClassBlockColorPipe} from './tclass-block-color/tclass-block-color.pipe';
import {TClassBlockNamePipe} from './tclass-block-name/tclass-block-name.pipe';
import { DurationTranslatePipe } from './duration-translate/duration-translate.pipe';
import {LocalizedDatePipe} from './localized-date-pipe/localized-date-pipe.pipe';
import { CurrencyPortfolioPipe } from './currency-portfolio/currency-portfolio.pipe';
import { DateTimeFormatPreferencePipe } from './date-time-format-preference/date-time-format-preference.pipe';
import { ShortDurationPipe } from './short-duration/short-duration.pipe';
import { IdentTextPipe } from './ident-text/indent-text.pipe';
import { CustomNumberFormatPipe } from "@wind-log_library/fe-component-library";
import { SmallDecimalPipe } from './small-decimal/small-decimal.pipe';
import { SafeHtmlPipe } from 'app/reporting/pipes/safe-html.pipe';

const PIPES = [
    StatusCodePipe,
    HealthCodePipe,
    WeatherIconPipe,
    CapitalizeFirstPipe,
    NoUnderscorePipe,
    WhitespaceToUnderscorePipe,
    ValueToMonthPipe,
    ColorStatusCodePipe,
    MonitorAlarmPipe,
    ConvertPowerPipe,
    FileServerUrlPipe,
    DurationPipe,
    SafeHtmlPipe,
    SignalPropertiesPipe,
    LoadPipe,
    UserAccessPipe,
    CurrencyUnitsPipe,
    DateDifferencePipe,
    ImageSrcDependsOnThemePipe,
    ThemeColorPipe,
    NegativeToZeroPipe,
    ThemeColorPipe,
    PlaningEventCategoryColorPipe,
    CustomTranslatePipe,
    GetKpiForTablePipe,
    TClassBlockColorPipe,
    TClassBlockNamePipe,
    DurationTranslatePipe,
    LocalizedDatePipe,
    CurrencyPortfolioPipe,
		DateTimeFormatPreferencePipe,
    ShortDurationPipe,
    IdentTextPipe,
    SmallDecimalPipe
];

@NgModule({
    imports: [ CommonModule ],
    declarations: PIPES,
    providers: [PIPES, 
      CustomNumberFormatPipe
    ],
    exports: PIPES
})
export class PipesModule {}
